import { Heatmap } from 'components/duex/Heatmap';
import moment from 'moment';
import React, { ReactElement } from 'react';
import { AnalyticsProps } from '../answer-analytics.modal';

export function OverviewGraph({ usageCounts }: AnalyticsProps): ReactElement {
    return <Heatmap activity={usageCounts} startDate={moment().subtract(1, 'year')} descriptor="Usage" scale={4} />;
}
